import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import PaymentInstrumentDataPropsReactNative from '../../_common/PaymentInstrumentDataPropsReactNative.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Group summary='Properties' mdxType="Group">
      <Item title='analyticsId' subtitle='string' mdxType="Item">
        <p>{`An unique identifier for the payment instrument token.`}</p>
      </Item>
      <Item title='id' subtitle='string' mdxType="Item">
        <p>{`Payment method identifier.`}</p>
      </Item>
      <Item title='isVaulted' subtitle='boolean' mdxType="Item">
        <p>{`Indicating the use of vaulted instruments for the payment method.`}</p>
      </Item>
      <Item title='paymentInstrumentData' subtitle='PaymentInstrumentData' mdxType="Item">
        <p>{`Additional information about the payment instrument.
Depending on the payment method type, only some of the following properties are present on the object.`}</p>
        <PaymentInstrumentDataPropsReactNative mdxType="PaymentInstrumentDataPropsReactNative" />
      </Item>
      <Item title='paymentInstrumentType' subtitle='string' mdxType="Item">
        <p>{`The type of the payment instrument.`}</p>
        <p>{`Example of possible values (new values could be added as we add new payment methods):`}</p>
        <ul>
          <li parentName="ul"><inlineCode parentName="li">{`APPLE_PAY`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`CARD_OFF_SESSION_PAYMENT`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`GOOGLE_PAY`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`KLARNA_CUSTOMER_TOKEN`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`OFF_SESSION_PAYMENT`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`PAYMENT_CARD`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`PAYPAL_BILLING_AGREEMENT`}</inlineCode></li>
          <li parentName="ul"><inlineCode parentName="li">{`PAYPAL_ORDER`}</inlineCode></li>
        </ul>
      </Item>
      <Item title='token' subtitle='string' label='Required' mdxType="Item">
        <p>{`The payment instrument token you can use to `}<a parentName="p" {...{
            "href": "https://primer.io/docs/api/api-reference/payments-api/create-payment"
          }}>{`create a payment request`}</a>{` from your backend.`}</p>
      </Item>
      <Item title='tokenType' subtitle='"SINGLE_USE" | "MULTI_USE"' mdxType="Item">
Whether this payment method token can be used only once or multiple times.
      </Item>
      <Item title='threeDSecureAuthentication' subtitle='ThreeDSAuthenticationData' mdxType="Item">
        <Group summary='Properties' mdxType="Group">
          <Item title='responseCode' subtitle='ThreeDSecureStatus' mdxType="Item">
            <p>{`Indicates the outcome of the 3D Secure authentication process.`}<br parentName="p"></br>{`
`}{`Possible values:  `}</p>
            <ul>
              <li parentName="ul"><inlineCode parentName="li">{`AUTH_SUCCESS`}</inlineCode>{`: The authentication was successful.  `}</li>
              <li parentName="ul"><inlineCode parentName="li">{`AUTH_FAILED`}</inlineCode>{`: The authentication process failed.  `}</li>
              <li parentName="ul"><inlineCode parentName="li">{`SKIPPED`}</inlineCode>{`: The authentication was skipped.  `}</li>
              <li parentName="ul"><inlineCode parentName="li">{`CHALLENGE`}</inlineCode>{`: A challenge was issued during the authentication process.  `}</li>
            </ul>
          </Item>
          <Item title='reasonCode' subtitle='string' mdxType="Item">
An optional code indicating the reason for the outcome of the 3D Secure authentication.
          </Item>
          <Item title='reasonText' subtitle='string' mdxType="Item">
An optional text description providing further details about the reason for the authentication outcome.
          </Item>
          <Item title='protocolVersion' subtitle='string' mdxType="Item">
Specifies the version of the 3D Secure protocol that was used.
          </Item>
          <Item title='challengeIssued' subtitle='boolean' mdxType="Item">
            <p>{`Indicates whether a challenge was issued as part of the authentication process.  `}</p>
            <ul>
              <li parentName="ul"><inlineCode parentName="li">{`true`}</inlineCode>{`: A challenge was issued.  `}</li>
              <li parentName="ul"><inlineCode parentName="li">{`false`}</inlineCode>{`: No challenge was issued.`}</li>
            </ul>
          </Item>
        </Group>
      </Item>
      <Item title='vaultData' subtitle='PrimerVaultData' mdxType="Item">
        <Group summary='Properties' mdxType="Group">
          <Item title='customerId' subtitle='string' mdxType="Item">
            <p>{`The `}<inlineCode parentName="p">{`customerId`}</inlineCode>{` associated to the payment method, if vaulted.`}</p>
          </Item>
        </Group>
      </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      